import { useState } from 'react';
import { CircularProgress } from '@material-ui/core';

import {
  addQuestionToArchive,
  restoreQuestionFromArchive,
  deleteQuestionFromArchive,
} from '../../../services/apiService';

function Question({ ques, index, editQues, updateList }) {
  const [collapsible, collapse] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const addToArchive = async (questionId) => {
    try {
      setIsLoading(true);
      await addQuestionToArchive(questionId);
      updateList();
    } catch (err) {
      console.error(err);
    }
  };

  const restoreFromArchive = async (questionId) => {
    try {
      setIsLoading(true);
      await restoreQuestionFromArchive(questionId);
      updateList();
    } catch (err) {
      console.error(err);
    }
  };

  const deleteFromArchive = async (questionId) => {
    try {
      setIsDeleting(true);
      await deleteQuestionFromArchive(questionId);
      updateList();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <div className='flex justify-between text-gray-400 p-4'>
        <div>
          <h1
            onClick={() => collapse(!collapsible)}
            className='text-gray-700 cursor-pointer text-lg'
          >
            Q {index + 1}. {ques.question}
          </h1>

          <p hidden={collapsible} className='font-normal text-gray-600 my-2'>
            <pre>
              <code>
                {ques.solution}
              </code>
            </pre>
          </p>

          <div className='mt-4 mb-2 flex gap-8'>
            <span>
              Difficulty Level:{' '}
              <span className='text-gray-500 capitalize'>
                {ques.difficultyLevel}
              </span>
            </span>
            <span>
              Concept (L3):{' '}
              <span className='text-gray-500'>
                {ques.Concept?.name || ques.conceptId}
              </span>
            </span>
            <span>
              Ques ID: <span className='text-gray-500'>{ques.id}</span>
            </span>
          </div>
        </div>
        <div className='text-xl'>
          <i
            className={
              collapsible
                ? 'fas fa-caret-down'
                : 'fas fa-caret-up text-gray-700'
            }
          />
        </div>
      </div>

      {ques.type === 'archived' ? (
        <div className='text-right px-4 mb-4'>
          <button
            onClick={() => deleteFromArchive(ques.id)}
            className='border border-gray-300 font-medium text-gray-500 rounded w-64 py-2 mr-4'
            disabled={isDeleting || isLoading}
          >
            {isDeleting ? (
              <CircularProgress size='1.5rem' className='-my-1.5' />
            ) : (
              <span>Delete</span>
            )}
          </button>
          <button
            onClick={() => restoreFromArchive(ques.id)}
            className='border border-gray-300 font-medium text-white rounded w-64 py-2 bg-blue-c1'
            disabled={isLoading || isDeleting}
          >
            {isLoading ? (
              <CircularProgress
                size='1.5rem'
                className='-my-1.5'
                color='inherit'
              />
            ) : (
              <span>Restore From Archive</span>
            )}
          </button>
        </div>
      ) : (
        <div className='text-right px-4 mb-4'>
          <button
            onClick={() => editQues(ques)}
            className='border border-gray-300 font-medium text-gray-500 rounded w-64 py-2 mr-4'
            disabled={isLoading}
          >
            Edit
          </button>
          <button
            onClick={() => addToArchive(ques.id)}
            className='border border-gray-300 font-medium text-gray-500 rounded w-64 py-2'
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress size='1.5rem' className='-my-1.5' />
            ) : (
              <span>Add To Archive</span>
            )}
          </button>
        </div>
      )}
    </div>
  );
}

export default Question;
